module.exports = __webpack_public_path__ + "static/media/map_accent_left.813941f5.svg";